export default "__VITE_ASSET__BbQKQNOY__"